export default {
  methods: {
    studioAiLink(url) {
      // stage.motionelements.com => stage-ai.motionelements.com
      // www.motionelements.com => ai.motionelements.com
      return url.replace('stage.motionelements.com', 'stage-ai.motionelements.com')
        .replace('www.motionelements.com', 'ai.motionelements.com');
    },
  },
};
